// extracted by mini-css-extract-plugin
export var contrastLow = "_n-1";
export var externalLink = "_n-2";
export var externalLinkIcon = "_n-3";
export var link = "_n-0";
export var linkLabel = "_n-4";